import { render, staticRenderFns } from "./ExchangeLogin.vue?vue&type=template&id=98e763da&"
import script from "./ExchangeLogin.vue?vue&type=script&lang=js&"
export * from "./ExchangeLogin.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeLogin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports